import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import Quasar from 'quasar/src/vue-plugin.js';;
import quasarUserOptions from "./quasar-user-options";
import { registerGlobalComponents } from "./components";
import VCalendar from '@peeraop21/v-calendar-buddhist';
import '@peeraop21/v-calendar-buddhist/style.css';

const app = createApp(App);
registerGlobalComponents(app);
app.use(Quasar, quasarUserOptions)
  .use(store)
  .use(router)
  .use(i18n)
  .use(VCalendar)
  .mount("#app");
